export const regFormData = {
  regAddressFields: [
    {
      htmlFor: "city",
      id: "city",
      label: "formReg.city",
      name: "city",
      placeholder: "formReg.phldr.city",
      required: true,
      type: "text",
    },
    {
      htmlFor: "zipCode",
      id: "zipCode",
      label: "formReg.zipCode",
      name: "zipCode",
      placeholder: "7503",
      required: true,
      type: "text",
    },
    {
      htmlFor: "street",
      id: "street",
      label: "formReg.street",
      name: "street",
      placeholder: "formReg.phldr.street",
      required: true,
      type: "text",
    },
    {
      htmlFor: "streetNumber",
      id: "streetNumber",
      label: "formReg.streetNumber",
      name: "streetNumber",
      placeholder: "55",
      required: true,
      type: "text",
    },
  ],
  regGeneralInfoFields: [
    {
      htmlFor: "companyName",
      id: "companyName",
      label: "formReg.companyName",
      name: "companyName",
      placeholder: "formReg.phldr.companyName",
      required: true,
      type: "text",
    },
    {
      htmlFor: "email",
      id: "email",
      label: "form.email",
      name: "email",
      placeholder: "form.phldr.email",
      required: true,
      type: "email",
    },
    {
      htmlFor: "phone",
      id: "phone",
      label: "formReg.phone",
      name: "phone",
      placeholder: "+49 69 1234 5678",
      required: true,
      type: "phone",
    },
    {
      htmlFor: "firstName",
      id: "firstName",
      label: "formReg.firstName",
      name: "firstName",
      placeholder: "formReg.phldr.firstName",
      required: true,
      type: "text",
    },
    {
      htmlFor: "lastName",
      id: "lastName",
      label: "formReg.lastName",
      name: "lastName",
      placeholder: "formReg.phldr.lastName",
      required: true,
      type: "text",
    },
    {
      htmlFor: "website",
      id: "website",
      label: "formReg.website",
      name: "website",
      placeholder: "formReg.phldr.website",
      required: false,
      type: "website",
    },
  ],
  regRadioInfoFields: [
    {
      name: "role",
      text: "formReg.carDealer.desc",
      title: "formReg.carDealer",
      type: "radio",
      value: "Car",
    },
    {
      name: "role",
      text: "formReg.motoDealer.desc",
      title: "formReg.motoDealer",
      type: "radio",
      value: "Moto",
    },
    {
      name: "role",
      text: "formReg.carMotoDealer.desc",
      title: "formReg.carMotoDealer",
      type: "radio",
      value: "Car and Moto Dealer",
    },
  ],
};
